module.exports = __webpack_public_path__ + "img/securecloud.1cfd0465.png";